import { ADMIN_ROLES, ADMIN_ROLE_RANK } from '../../../../packages/types/admin'

export function hasAdminClaim(tokenResult) {
  return tokenResult?.claims?.admin === true
}

/** custom claim의 adminRole 값(있다면) — admins/{uid} 문서를 못 읽었을 때의 표시용 폴백일 뿐,
 * 실제 인가 판단(admins/{uid}가 원본)에는 쓰지 않는다. */
export function claimRole(tokenResult) {
  const role = tokenResult?.claims?.adminRole
  return ADMIN_ROLES.includes(role) ? role : null
}

export function isValidAdminRole(role) {
  return ADMIN_ROLES.includes(role)
}

/** role이 minRole 이상인지(owner > admin > editor > viewer) — 서버 requireAdmin()과 동일한 랭크 기준. */
export function hasMinRole(role, minRole) {
  return ADMIN_ROLE_RANK[role] !== undefined && ADMIN_ROLE_RANK[minRole] !== undefined && ADMIN_ROLE_RANK[role] >= ADMIN_ROLE_RANK[minRole]
}
